/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCouponUpdateReqVo
 */
export interface UserCouponUpdateReqVo {
    /**
     * 用户 ID，必传
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    userId: number;
    /**
     * 优惠券名称，必传
     * @type {string}
     * @memberof UserCouponUpdateReqVo
     */
    name: string;
    /**
     * 有效期开始时间，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss
     * @type {string}
     * @memberof UserCouponUpdateReqVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss
     * @type {string}
     * @memberof UserCouponUpdateReqVo
     */
    endTime?: string;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserCouponUpdateReqVo
     */
    currencyCode: string;
    /**
     * 优惠券金额，字符串类型，支持小数，必传
     * @type {string}
     * @memberof UserCouponUpdateReqVo
     */
    amount: string;
    /**
     * 是否可转让：0-不可转让，1-可转让，必传
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    canTrans: number;
    /**
     * 优惠券作用于的附加服务 ID 列表，JSON 数组格式，如  [1,2,3,4] 可选
     * @type {Array<number>}
     * @memberof UserCouponUpdateReqVo
     */
    additionalServiceIds?: Array<number>;
    /**
     * 优惠券发放数量，必须大于 0，必传
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    number: number;
    /**
     * 优惠券来源：1-系统发放，2-其他用户转来，必传
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    source: number;
    /**
     * 源用户 ID，当来源为 2（其他用户转来）时必填，可选
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    sourceUserId?: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    enable: number;
    /**
     * 发放方式 1 管理员发放，2 活动发放
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    grantType: number;
    /**
     * 是否长期有效：0-否，1-是
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    longTerm: number;
    /**
     * 用户优惠券使用状态：1待使用 2已使用 3已过期 4已退回（不可用看 enable 字段）
     * @type {number}
     * @memberof UserCouponUpdateReqVo
     */
    userCouponStatus: number;
}

/**
 * Check if a given object implements the UserCouponUpdateReqVo interface.
 */
export function instanceOfUserCouponUpdateReqVo(value: object): value is UserCouponUpdateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('canTrans' in value) || value['canTrans'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('grantType' in value) || value['grantType'] === undefined) return false;
    if (!('longTerm' in value) || value['longTerm'] === undefined) return false;
    if (!('userCouponStatus' in value) || value['userCouponStatus'] === undefined) return false;
    return true;
}

export function UserCouponUpdateReqVoFromJSON(json: any): UserCouponUpdateReqVo {
    return UserCouponUpdateReqVoFromJSONTyped(json, false);
}

export function UserCouponUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCouponUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'name': json['name'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'currencyCode': json['currencyCode'],
        'amount': json['amount'],
        'canTrans': json['canTrans'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : json['additionalServiceIds'],
        'number': json['number'],
        'source': json['source'],
        'sourceUserId': json['sourceUserId'] == null ? undefined : json['sourceUserId'],
        'enable': json['enable'],
        'grantType': json['grantType'],
        'longTerm': json['longTerm'],
        'userCouponStatus': json['userCouponStatus'],
    };
}

export function UserCouponUpdateReqVoToJSON(json: any): UserCouponUpdateReqVo {
    return UserCouponUpdateReqVoToJSONTyped(json, false);
}

export function UserCouponUpdateReqVoToJSONTyped(value?: UserCouponUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
        'currencyCode': value['currencyCode'],
        'amount': value['amount'],
        'canTrans': value['canTrans'],
        'additionalServiceIds': value['additionalServiceIds'],
        'number': value['number'],
        'source': value['source'],
        'sourceUserId': value['sourceUserId'],
        'enable': value['enable'],
        'grantType': value['grantType'],
        'longTerm': value['longTerm'],
        'userCouponStatus': value['userCouponStatus'],
    };
}

